import status from './status';
import applicationUI from './ui/applicationUI';
import miniCartUI from './ui/miniCartUI';
import cartMaxUI from './ui/cartMaxUI';
import dropdownNavUI from './ui/dropdownNavUI';
import mobileNavUI from './ui/mobileNavUI';
import customerUI from './ui/customerUI';
import productUI from './ui/productUI';
import locationsUI from './ui/locationsUI';
import locations from './locations';
import products from './products';
import customer from './customer';
import genericPage from './genericPage';
import events from './events';
import articles from './articles';
import wholesale from './wholesale';
import flavors from './flavors';
import bookings from './bookings';

export default {
  status,
  applicationUI,
  miniCartUI,
  cartMaxUI,
  dropdownNavUI,
  customerUI,
  locationsUI,
  productUI,
  locations,
  products,
  customer,
  genericPage,
  events,
  mobileNavUI,
  articles,
  wholesale,
  flavors,
  bookings
};



// WEBPACK FOOTER //
// ./src/state/reducers/index.js